export default __webpack_public_path__ + "static/image 56-ff5855ee61ab54caaca29697bef300bf.png";